import React from 'react';
import { AlbumCard } from '../../components/content/AlbumCard';
import { useWebLocale } from '../../contexts/WebLocaleContext';

// iOS58 ExploreLandingScreen: TimelineAlbumCard showDecade + accentRating,
// no showContext/showDiscoveryReason. Keep this surface distinct from Timeline detail.
export function ExploreEraCard({ item }) {
  const { locale } = useWebLocale();
  const album = item.album;
  const year = Number.parseInt(album.releaseDate?.slice(0, 4), 10);
  const decade = Number.isFinite(year) ? Math.floor(year / 10) * 10 : null;
  const card = {
    id: album.id,
    slug: album.slug,
    albumSource: album.albumSource,
    sourceId: album.sourceId,
    title: album.title,
    imageUrl: album.imageUrl,
    artist: album.artist,
    contentRating: album.contentRating,
    averageRating: album.averageRating ?? 0,
    caption: decade === null ? '' : locale === 'ko' ? `${decade}년대` : `${decade}s`,
  };
  return (
    <div className="pp-era-card">
      <AlbumCard item={card} showEmptyRating showAdMark={false} />
    </div>
  );
}
